"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
//@ts-ignore
const services_1 = require("@qsite/services");
const formik_1 = require("formik");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const __1 = require("../");
function focusOnFirstInvalidField(errors, touched) {
    if (!lodash_1.default.isEmpty(errors)) {
        const firstInvalidField = Object.keys(errors)[0];
        document.getElementsByName(firstInvalidField)[0].focus();
    }
    else if (!lodash_1.default.isEmpty(touched)) {
        const firstTouchedField = Object.keys(touched)[0];
        document.getElementsByName(firstTouchedField)[0].focus();
    }
}
const Form = ({ className, initialValues, validationSchema, onSubmit, onCancel, primaryButtonLabel, secondaryButtonLabel, fields, children }) => {
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit, validateOnChange: true, validateOnBlur: true }, ({ values, errors, touched, handleChange, handleSubmit, isSubmitting, setFieldValue, isValid }) => (react_1.default.createElement("form", { className: className, "data-testid": 'form', onSubmit: handleSubmit },
        react_1.default.createElement(__1.Grid, { gridTemplateColumns: 'repeat(2, 1fr)', gridGap: '10px', mobileGridTemplateColumns: '1fr', gridWidth: '650px' },
            isSubmitting && !isValid && focusOnFirstInvalidField(errors, touched),
            fields.map((field) => services_1.formFieldFactory({
                field,
                handleChange: field.customHandleChange || handleChange,
                values,
                errors,
                touched,
                setFieldValue
            })),
            children),
        secondaryButtonLabel &&
            react_1.default.createElement(__1.Button, { type: 'button', onClick: onCancel, buttonTheme: 'light', label: secondaryButtonLabel, dataTestId: 'form-secondary-button', disabled: isSubmitting }),
        react_1.default.createElement(__1.Button, { type: 'submit', label: primaryButtonLabel, dataTestId: 'form-submit-button', disabled: isSubmitting })))));
};
exports.Form = Form;
